import React, { useContext } from "react";
import DatePicker from "react-datepicker";
import { useController } from "react-hook-form";

import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";

const EnquiryInfoDatePicker = ({ id, name, control, className }) => {
  const { isMobileDevice } = useContext(ViewContext);
  const {
    field: { onChange, onBlur, value, ref },
  } = useController({
    name,
    control,
  });

  const [startDate, endDate] = value;

  const today = new Date();

  return (
    <div className={className}>
      <DatePicker
        id={id}
        selected={startDate}
        onChange={onChange}
        onBlur={onBlur}
        dateFormat="d/MM/yyyy"
        ref={ref}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        minDate={today}
        // Render Mobile version with Portal Layout so calendar doesn't get cuttoff
        withPortal={isMobileDevice}
      />
    </div>
  );
};

export default EnquiryInfoDatePicker;
